// extracted by mini-css-extract-plugin
export default {"InteractiveFilters":"D748y8r_anlrerquvQrH","TextFragment":"rHFqkiNumTenD4irnsC2","Variant--light":"zscfdH77cD88Vh_HFszr","Variant--dark":"e_W0uHRB40T8YyJGvMHQ"};